import Container from "@mui/material/Container";
import LinearProgress from "@mui/material/LinearProgress";
import { useLottie } from "lottie-react";

import loadingAnimation from "../lottie/loadingAnimation.json";
import styles from "./loadingUpAnimation.module.css";

type Props = {
    progress?: number
}

const LoadingUpAnimation = ({ progress = 0 }: Props): JSX.Element => {
    const options = {
        animationData: loadingAnimation,
        loop: true,
    };
    const { View } = useLottie(options);
    return (
        <Container className={styles.up_animation_loader_wrapper}>
            {View}
            {progress > 0 && <LinearProgress value={progress} variant="determinate" />}
        </Container>
    );
}

LoadingUpAnimation.defaultProps = {
    progress: 0
}

export default LoadingUpAnimation;
